import classNames from 'classnames';

import { BINGO_DAUB_BG, BINGO_DIAMOND_BG, BINGO_NEW_PLAYER_BG } from '../../../../constants';
import type { BingoWidgetFeatureType } from '../../../../types';

import styles from './BingoWideWidgetBackground.module.scss';

interface BingoWideWidgetBackgroundProps {
  bgType: BingoWidgetFeatureType;
}

const scrMap: Record<BingoWidgetFeatureType, string | null> = {
  general: null,
  daub: BINGO_DAUB_BG,
  diamond: BINGO_DIAMOND_BG,
  newPlayer: BINGO_NEW_PLAYER_BG,
};

export function BingoWideWidgetBackground(props: BingoWideWidgetBackgroundProps) {
  const { bgType } = props;
  const imgSrc = scrMap[bgType];

  return (
    <div className={classNames(styles.container, bgType === 'general' && styles.bgGeneral)}>
      {imgSrc && <img alt="" className={styles.bgImage} src={imgSrc} />}
    </div>
  );
}
